<template>
    <v-row >
        <v-col cols="12" md="8">
            <gmap-map ref="gmap"
                    :center="center"
                    :zoom="12"
                    style="width:100%;  height: 680px;"
            >
                <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        :title ="m.title"
                        :label = "m.label"
                        :icon = "m.icon"
                        @click="itemClick(m)"
                ></gmap-marker>
            </gmap-map>
        </v-col>
        <v-col cols="12" md="4" :order="$vuetify.breakpoint.mdAndUp?2:1">
            <v-card
                    class="mx-auto mb-8"
            >
                <v-sheet dark
                         color="#0CBBD6"
                         class="mx-auto pa-2"
                         elevation="8"
                         max-width="calc(100% - 16px)"
                         height="100px"
                >
                    <form @submit.prevent="search">
                        <v-row no-gutters class="justify-space-between">
                            <v-col class="text-center">
                                <label>
                                       Search by miles around user
                                </label>
                            </v-col>
                        </v-row>
                        <v-row class="lightbox fill-height" >
                            <v-col>
                                <v-switch class="mt-0"
                                        v-model="mapQueryEnable"
                                        :label="mapQueryEnable?'Disable':'Enable'"
                                        color="white"
                                          dense
                                          inset
                                          flat
                                >
                                </v-switch>
                            </v-col>
                            <v-col >
                                <v-text-field
                                        label=""
                                        v-mask="'###'"
                                        v-model="miles"
                                        :disabled = "!mapQueryEnable"
                                        class="ma-0 pa-0">
                                </v-text-field>
                            </v-col>
                            <v-col >
                                <v-btn  type="submit"
                                        icon>
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </form>
                </v-sheet>
                <v-row>
                    <v-col class="pa-6">
                        <autocomplete :items="items"
                                      label="Select"
                                      title="text"
                                      :sub-title="['subtitle']"
                                      :selected-items="selectedItems"
                                      @autocomplete-selected="updateSelectedItems($event)"
                        >
                        </autocomplete>
                    </v-col>
                </v-row>

                <v-card-actions>
                    <v-row no-gutters>
                        <v-col align-self="center">
                            <responsiveButton :setText="true"
                                              setColor="orange"
                                              setDefaultIcon="mdi-account-multiple-plus"
                                              setSmallIcon="mdi-account-multiple-plus"
                                              :setClick="assign"
                            >
                                Assign
                            </responsiveButton>
                            <responsiveButton :setText="true"
                                              setColor="red"
                                              setDefaultIcon="mdi-cancel"
                                              setSmallIcon="mdi-cancel"
                                              :setClick="goBack"
                            >
                                Cancel
                            </responsiveButton>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    const Autocomplete = ()=> import( "@/components/common/Autocomplete");
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');
    import {MAP_ICONS} from "@/shared/enums/MapIcons";
    import {mapGetters, mapState, mapActions, mapMutations} from "vuex";

    export default {
        name: "AssigmentView",
        components: {Autocomplete, responsiveButton},
        props:["id", "type", "assignmentFor"],
        data(){
            return{
                path_id: this.id,
                path_type: this.type,
                user: null,
                selectedItems: [],
                selectedMarkers: [],
                //list
                miles: 50,
                page:0,
                size:1,
                items: [],
                //maps
                center: { lat: 25.7617, lng: -80.1918 },
                markers: [],
                places: [],
                currentPlace: null,
                mapQueryEnable: false
            }
        },
        watch:{
            id(value){
                this.path_id = value;
            },
            type(value){
                this.path_type = value;
            },
        },
        computed:{
            //('namespace','array of methods') OR ({'namespace/method':new function name})
          ...mapGetters("assignment", ['getUsers']),
          ...mapState("assignment", ['users'])
        },
        methods:{
            ...mapMutations("assignment", ['setUsers']),
            ...mapActions('assignment', ['getClientsForAssignment', 'getEmployeesForAssignment']),
            async search(){
                let data = {
                    id: this.path_type == 'Employee'?this.user.typeID: this.user.authorizationRuleId,
                    latitude: this.user.geoPoint.latitude,
                    longitude: this.user.geoPoint.longitude,
                    radius: (this.miles * 1609.34),
                    map:this.mapQueryEnable
                };
                this.markers = []
                this.addMarkerByAddress(this.user);
                await this.getAssignments(data);
            },
            updateSelectedItems(items){
                let removed = this.selectedMarkers.filter(elem =>{
                   if(items.length > 0){
                       return items.findIndex(elem2 => elem2.id == elem.id) == -1
                   }
                   return true;
                });

                let inserted = items.filter(elem => {
                    if(this.selectedMarkers.length > 0){
                        return this.selectedMarkers.findIndex(elem2 => elem2.id == elem.id) != -1
                    }
                    return true;
                });

                if(removed.length > 0){
                    removed.forEach( elem => {
                        let index = this.selectedMarkers.findIndex(elem2 => elem2.id == elem.id);
                        this.selectedMarkers.splice(index,1);
                        elem.icon =  this.type == 'Employee'? MAP_ICONS.CLIENT : MAP_ICONS.EMPLOYEE;;
                    })
                }

                if(inserted.length >0){
                    inserted.forEach( elem => {
                        let index =  this.markers.findIndex(elem2 => elem2.id == elem.id);
                        let marker = this.markers[index];
                        this.selectedMarkers.push(marker);
                        marker.icon = MAP_ICONS.SELECTED;
                    })
                }
                this.selectedItems = items;
                this.$log.debug("selected items :: ", this.selectedItems);
            },
            goBack(){
                //go back to
                let backTo = this.path_type == 'Employee' ? 'employeeDetailsClientsTable' : 'clientDetailsEmployeesTable'
                this.$router.push({name: backTo, params:{id:this.id}});
            },
            async assign(){
                //new list of employee client
                let previousAssigments = {};
                if(this.user[this.assignmentFor.toLowerCase()] !== undefined &&
                    Object.keys(this.user[this.assignmentFor.toLowerCase()]).length > 0){
                    //deepCopy
                    previousAssigments =JSON.parse(JSON.stringify(this.user[this.assignmentFor.toLowerCase()]));
                }

                let newAssigments = this.selectedItems.filter(elem =>{
                    if(this.user[this.assignmentFor.toLowerCase()] !== undefined &&
                        Object.keys(this.user[this.assignmentFor.toLowerCase()]).length > 0){
                        return this.user[this.assignmentFor.toLowerCase()][elem.id] !== undefined;
                    }
                    return true;
                }).reduce((obj,elem)=>{
                           obj[elem.id] = {
                               name: elem.text,
                               address: elem.address,
                               typeID: elem.typeID,
                               typeName: elem.typeName
                           }
                    return obj;
                }, previousAssigments);

                if(this.user[this.assignmentFor.toLowerCase()] === undefined){
                    this.user[this.assignmentFor.toLowerCase()] = {};
                }

                this.user[this.assignmentFor.toLowerCase()] = newAssigments;
                let setForType = `set${this.path_type}`;
                await this.$store.dispatch(setForType, this.user);

                //set client employee
                Object.keys(newAssigments).forEach(async (elem) => {
                    let id = elem;
                    let getFor = `get${this.path_type == 'Employee'? 'Client': 'Employee'}`;
                    await this.$store.dispatch(getFor, {id: id});
                    let other = this.$store.getters[getFor];
                    if (other[this.path_type.toLowerCase()+'s'] === undefined){
                        other[this.path_type.toLowerCase()+'s'] = {};
                    }

                    other[this.path_type.toLowerCase()+'s'][this.user.id] = {
                        name: this.user.name,
                        address: `${this.user.address.address_line_1}, `+
                            `${this.user.address.city} ${this.user.address.state} ${this.user.address.zip_code}`,
                        typeID: this.user.typeID,
                        typeName: this.user.typeName
                    };
                    let setFor = `set${this.path_type == 'Employee'? 'Client': 'Employee'}`;
                    await this.$store.dispatch(setFor, other);
                })

                //go back to
                this.goBack();
            },
            itemClick(marker){
                this.$log.debug("marker user :: ", marker)
                if(marker.title == this.type){
                    return;
                }

                let elementFound = this.selectedItems.findIndex(elem => elem.id == marker.id);

                if(elementFound == -1){
                    this.selectedItems.push({
                        text: marker.text,
                        subtitle: marker.subtitle,
                        id: marker.id,
                        address: marker.address,
                        typeID: marker.typeID,
                        typeName: marker.typeName
                    });

                    this.selectedMarkers.push(marker);
                    marker.icon = MAP_ICONS.SELECTED;
                }
                else {
                    this.selectedItems.splice(elementFound, 1);
                    let index = this.selectedMarkers.findIndex(elem => elem.id == marker.id);
                    this.selectedMarkers.splice(index,1);

                    marker.icon = this.type == 'Employee'? MAP_ICONS.CLIENT : MAP_ICONS.EMPLOYEE;
                }
            },
            async loadData(){
                try {
                    //call store type
                    let getForType = 'get'+this.path_type;
                    await this.$store.dispatch(getForType, {id: this.path_id});
                    let user = this.$store.getters[getForType];

                    if(!!!user){
                        throw {message: `Not valid ${this.path_type} found for id: ${this.path_id}`};
                    }

                    if(this.type.toLowerCase() == 'employee'){
                        let userCognito = this.$store.getters.getCognitoUser;
                        if(userCognito === null || userCognito.Username !== user.cognitoUsername) {
                            await this.$store.dispatch('getCognitoUser', {username: user.cognitoUsername});
                            userCognito = this.$store.getters.getCognitoUser;
                        }

                        if(userCognito){
                            user.username = userCognito.Username;
                            user.attributes= {};
                            for(let property in userCognito.UserAttributes){
                                user.attributes[userCognito.UserAttributes[property].Name] = userCognito.UserAttributes[property].Value;
                            }

                            user.attributes.phone_number = user.attributes.phone_number.replace(/\+1/,'');
                            user.address = JSON.parse(user.attributes.address);
                        }
                        user.icon = MAP_ICONS.EMPLOYEE;

                    }
                    //client
                    else {
                        user.icon = MAP_ICONS.CLIENT;
                    }
                    user.accType = this.type == 'Employee'? 'Employee' : 'Client';
                    this.user = user;
                }
                catch (e) {
                    //set alert
                    this.$log.debug(e);
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }
            },
            addMarkerByAddress(user){
                this.$log.debug("adding address marker: " , user.geoPoint);
                let names = user.name.split(' ');
                let initials = names[0].charAt(0)+(names[1] ? names[1].charAt(0) : '');
                let accType = user.accType;
                let icon = user.icon;
                // create marker;
                const marker = {
                    position:{
                        lat: user.geoPoint.latitude,
                        lng: user.geoPoint.longitude
                    },
                    title: accType,
                    label: {
                        text: initials,
                        color: 'black',
                        fontSize: '16px',
                    },
                    icon: icon,
                    id: user.id,
                    text: user.text,
                    subtitle: user.subtitle,
                    address: user.address,
                    typeID: user.typeID,
                    typeName: user.typeName
                };

                this.markers.push(marker);
                this.center = marker.position;
            },
            // receives a place object via the autocomplete component
            setPlace(place) {
                this.currentPlace = place;
            },
            async getAssignments(initPoint){
                let users = [];
                try{
                    //using new way to access store
                    await this[`get${this.assignmentFor}ForAssignment`](initPoint);
                    users = this.getUsers;
                }
                catch (e) {
                    //set alert
                    this.$log.debug(e);
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }

                this.items = [];
                this.selectedItems = [];
                this.selectedMarkers = [];

                users.forEach( elem => {
                    let textUser =  this.type == 'Client'? elem.name : `${elem.name} ${elem.family_name}`;
                    let subTitleUser = `${elem.address.address_line_1}, `+
                        `${elem.address.city} ${elem.address.state} ${elem.address.zip_code}`;

                    let element = {
                        ...elem,
                        name : `${elem.name} ${elem.family_name}`,
                        text: textUser,
                        accType: this.type == 'Employee'? 'Client' : 'Employee',
                        subtitle: subTitleUser,
                        icon: this.type == 'Employee'? MAP_ICONS.CLIENT : MAP_ICONS.EMPLOYEE,
                        address: subTitleUser,
                        typeID: elem.typeID,
                        typeName: elem.typeName
                    }

                    this.addMarkerByAddress(element)
                    let item = {
                        text: textUser,
                        subtitle: subTitleUser,
                        id: elem.id,
                        address: subTitleUser,
                        typeID: elem.typeID,
                        typeName: elem.typeName
                    }

                    this.items.push(item)

                    if(this.user[this.assignmentFor.toLowerCase()] !== undefined){
                        let index = this.user[this.assignmentFor.toLowerCase()][elem.id];
                        if(index != undefined){
                            this.selectedItems.push(item)
                        }
                    }
                });
            },
            centerMap(){
                let center = this.markers.reduce( (el1, el2) => { return {
                    position: {
                        lat: el1.position.lat + el2.position.lat,
                        lng: el1.position.lng + el2.position.lng
                    }
                }
                });
                let cnt  = this.markers.length;
                this.center = { lat: center.position.lat / cnt,
                                lng: center.position.lng / cnt};
            }
        },
        async created(){
            await this.loadData();
            await this.search();
            this.centerMap();
        }
    }
</script>

<style scoped>

</style>